module.exports = __webpack_public_path__ + "static/organisers-825416fd1b0a5af50f149017c6c8de42.jpg";